import React from 'react';
import Box from '../Box/Box';
import RowItemProps from './@types/RowItemProps';
import { TextBodySmall, TextBodyBase } from '../../components/Text';

const RowItem = ({ title, overline, subtitle, leftIcon, rightContent, className = '', ...rest }: RowItemProps) => (
  <Box as="div" className={className} name="RowItem" {...rest}>
    {leftIcon && (
      <Box as="span" name="RowItemLeft">
        <span aria-hidden="true">{leftIcon}</span>
      </Box>
    )}

    {/* Center content - Text content */}
    <Box as="div" name="RowItemContent">
      {overline && <TextBodySmall color="text-secondary">{overline}</TextBodySmall>}
      <TextBodyBase color="text-secondary">{title}</TextBodyBase>
      {subtitle && <TextBodySmall color="text-secondary">{subtitle}</TextBodySmall>}
    </Box>

    {/* Right side - Custom content */}
    {rightContent && (
      <Box as="span" name="RowItemRight">
        {rightContent}
      </Box>
    )}
  </Box>
);

export default RowItem;
